"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Titles = exports.Genders = exports.PaymentFrequencies = exports.States = exports.Scales = exports.AmbulanceProduct = exports.PreExistingConditions = exports.Bool = exports.Gender = exports.Title = exports.ARHIRetailRateCode = exports.PaymentFrequency = exports.State = exports.Scale = void 0;
const utils_1 = require("./utils");
exports.Scale = {
    Single: 'S',
    Couple: 'D',
    Family: 'F',
    SingleParentFamily: 'P'
};
exports.State = {
    ACT: 'A',
    NSW: 'N',
    NT: 'X',
    QLD: 'Q',
    SA: 'S',
    TAS: 'T',
    VIC: 'V',
    WA: 'W'
};
exports.PaymentFrequency = {
    Weekly: 'W',
    Fortnightly: 'F',
    Monthly: 'M',
    Quarterly: 'Q',
    HalfYearly: 'H',
    Yearly: 'Y'
};
exports.ARHIRetailRateCode = {
    DirectDebit: '4',
    Other: '0',
    CreditCard: '0',
    Braintree: '0'
};
exports.Title = {
    Mr: '1',
    Mrs: '2',
    Miss: '4',
    Ms: '5',
    Mx: '7',
    Dr: '70',
    Prof: '71',
    Sr: '75',
    Rev: '76',
    Father: '77',
    Brother: '78',
    Bishop: '79',
    Lady: '81',
    Captain: '82',
    Colonel: '83',
    Major: '84',
    Lord: '85',
    Sir: '80'
};
exports.Gender = {
    Female: 'F',
    Male: 'M'
};
const whicsTrue = 'Y';
const whicsFalse = 'N';
exports.Bool = {
    true: whicsTrue,
    false: whicsFalse,
    True: whicsTrue,
    False: whicsFalse
};
// key = Sales API-friendly ID, value = WHICS precondition code
exports.PreExistingConditions = {
    preExCancer: 4,
    preExDiabetes: 5,
    preExHeart: 7,
    preExJoint: 11,
    preExMedication: 8,
    preExMentalHealth: 12,
    preExOther: 10
};
exports.AmbulanceProduct = 'AMB';
exports.Scales = (0, utils_1.values)(exports.Scale);
exports.States = (0, utils_1.values)(exports.State);
exports.PaymentFrequencies = (0, utils_1.values)(exports.PaymentFrequency);
exports.Genders = (0, utils_1.values)(exports.Gender);
exports.Titles = (0, utils_1.values)(exports.Title);
//# sourceMappingURL=whics.js.map